import React from 'react';
import PropTypes from 'prop-types';
import './input.scss';

class InputPhone extends React.Component {
  constructor(props) {
    super(props);
    this.validate = this.validate.bind(this);
  }

  validate = e => {
    const value = e.target.value;
    e.target.value = value.replace(/[^0-9]/gi, '');
    this.props.changeState(e);
  };

  render() {
    const { maxLength, placeholder, error, errorMsg, name, value } = this.props;
    return (
      <div>
        <input
          type="tel"
          name={name}
          value={value}
          className="input"
          maxLength={maxLength}
          placeholder={placeholder}
          onChange={this.validate}
        />
        {error && <label className="label-error">{errorMsg}</label>}
      </div>
    );
  }
}

InputPhone.propTypes = {
  placeholder: PropTypes.string,
  error: PropTypes.bool,
  errorMsg: PropTypes.string,
  maxLength: PropTypes.number,
};

export default InputPhone;
